var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-policy"},[_c('div',{staticClass:"px-4 py-5"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.privacyPolicyTextKey, _vm.privacyPolicyDataObject))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }